import { useNavigate } from "react-router-dom";
import { useState, useEffect, Fragment } from "react";
import axios from "axios";
import "../../styles/navbar.scss";
//icons
import logo from "../../../images/logo.png";
import LogoutIcon from "@mui/icons-material/Logout";
import ListAltIcon from "@mui/icons-material/ListAlt";
import CoPresentIcon from "@mui/icons-material/CoPresent";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import StorefrontIcon from "@mui/icons-material/Storefront";
import PeopleIcon from "@mui/icons-material/People";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import VideoCameraFrontIcon from "@mui/icons-material/VideoCameraFront";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import DiscountIcon from "@mui/icons-material/Discount";
import AdUnitsIcon from "@mui/icons-material/AdUnits";
import WarehouseIcon from "@mui/icons-material/Warehouse";
//menu
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";

export default function DevNav(props) {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [pendingAlerts, setPendingAlerts] = useState(0);
  const [user, setUser] = useState("");
  const [authToken, setAuthToken] = useState("");

  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem("userDetails"));
    if (!userInfo) {
      navigate("/");
    } else {
      let getToken = localStorage.getItem("auth-token");
      setUser(userInfo.user);
      setAuthToken(getToken);
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    if (window.innerWidth < 690) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
    let getToken = localStorage.getItem("auth-token");
    const config = {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": getToken,
      },
    };

    axios
      .get(`${process.env.REACT_APP_API_URL}/onBoard/pending/managers`, config)
      .then((res) => {
        setPendingAlerts(res.data.length);
      })
      .catch((err) => {
        console.log(err);
      });

    if (getToken === "" || getToken === null || getToken === undefined) {
      Logout();
    }
  }, [window.innerWidth, windowWidth]);

  const Logout = () => {
    localStorage.setItem("userDetails", "");
    navigate("/");
  };

  return (
    <nav>
      <img
        src={logo}
        alt="NitroPOS logo"
        onClick={() => navigate("/dev-zone")}
      />
      <div className="menuSection">
        <PopupState>
          {(popupState) => (
            <>
              <div>
                <div className="switchZoneLabel" {...bindTrigger(popupState)}>
                  Switch zone
                </div>
                <p
                  style={{
                    margin: "5px",
                    fontSize: "12px",
                    textAlign: "center",
                  }}
                >
                  Dev zone
                </p>
              </div>
              <Menu {...bindMenu(popupState)}>
                <MenuItem onClick={() => navigate("/storezone")}>
                  <span className="mobile__icons">
                    <CoPresentIcon />
                    Store
                  </span>
                </MenuItem>
                <MenuItem onClick={() => navigate("/managerZone")}>
                  <span className="mobile__icons">
                    <StorefrontIcon />
                    Manager
                  </span>
                </MenuItem>
                {user.role === "Manager" || user.role === "Developer" ? (
                  <MenuItem onClick={() => navigate("/home")}>
                    <span className="mobile__icons">
                      <AdminPanelSettingsIcon />
                      Admin
                    </span>
                  </MenuItem>
                ) : null}
                {user.role === "Developer" || user.user === "guna@ghsl.uk" ? (
                  <MenuItem
                    onClick={() => navigate("/warehouse/v4u-disposables")}
                  >
                    <span className="mobile__icons">
                      <WarehouseIcon />
                      Warehouse
                    </span>
                  </MenuItem>
                ) : null}
                {user.vms ? (
                  <a
                    href={`https://vms.nitropos.co.uk/?token=${authToken}&name=${
                      user?.user || "NitroPOS"
                    }`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: "inherit",
                      textDecoration: "inherit",
                    }}
                  >
                    <MenuItem>
                      <span className="mobile__icons">
                        <AdUnitsIcon />
                        VMS
                      </span>
                    </MenuItem>
                  </a>
                ) : null}
              </Menu>
            </>
          )}
        </PopupState>
        <PopupState variant="popover" popupId="demo-popup-menu">
          {(popupState) => (
            <Fragment>
              <MenuOpenIcon
                {...bindTrigger(popupState)}
                fontSize="large"
                className="sideMenuIcon"
              />
              <Menu {...bindMenu(popupState)}>
                <MenuItem onClick={() => navigate("/dev-zone/cctv")}>
                  <span className="mobile__icons">
                    <VideoCameraFrontIcon />
                    CCTV
                  </span>
                </MenuItem>
                <MenuItem onClick={() => navigate("/cctv-status")}>
                  <span className="mobile__icons">
                    <QrCodeScannerIcon />
                    CCTV Status Change
                  </span>
                </MenuItem>
                <MenuItem
                  onClick={() => navigate("/dev-zone/failedTransactions")}
                >
                  <span className="mobile__icons">
                    <PriorityHighIcon />
                    Failed Transactions
                  </span>
                </MenuItem>

                <MenuItem onClick={() => navigate("/dev-zone/gs1")}>
                  <span className="mobile__icons">
                    <PlaylistAddIcon />
                    GS1 Barcodes
                  </span>
                </MenuItem>
                <MenuItem onClick={() => navigate("/dev-zone/audit-log")}>
                  <span className="mobile__icons">
                    <ListAltIcon />
                    Audit Log
                  </span>
                </MenuItem>
                <MenuItem onClick={() => navigate("/dev-zone/users")}>
                  <span className="mobile__icons">
                    <PeopleIcon />
                    Users
                  </span>
                </MenuItem>

                <MenuItem onClick={() => navigate("/dev-zone/promotions")}>
                  <span className="mobile__icons">
                    <DiscountIcon />
                    Booker Promotions
                  </span>
                </MenuItem>

                <MenuItem onClick={() => Logout()}>
                  <span className="mobile__icons">
                    <LogoutIcon />
                    Logout
                  </span>
                </MenuItem>
              </Menu>
            </Fragment>
          )}
        </PopupState>
      </div>
    </nav>
  );
}
